import React from 'react'

const SvgRelationshipTwoAOneTwo = () => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 964.1 1080"
    style={{
      enableBackground: "new 0 0 964.1 1080",
    }}
    xmlSpace="preserve"
  >
    <style>
      {
        ".st0{fill:none}.st5{fill:#cbd9e2}.st6{fill:#f6f4e1}.st7{fill:#fff}.st8{fill:#abc0ca}.st9{fill:#bccdd8}.st10{fill:#adc2ce}.st12{fill:#94aebc}.st15{fill:#dba795}.st16{fill:#333}.st17{fill:#e8a18e}.st18{fill:#713a39}.st19{fill:#a32b28}.st20{fill:#a02410}.st21{fill:#ad6b55}.st22{opacity:.2}.st23,.st24{fill:#9e695c}.st24{opacity:.2;enable-background:new}.st26{fill:#ff7a5a}.st29,.st30{fill:none;stroke:#7c4b87;stroke-linecap:round}.st29{stroke-linejoin:round}.st30{stroke-miterlimit:10}.st37{fill:#061a47}.st38{fill:#352d2d}.st42{fill:none;stroke:#0e2651;stroke-miterlimit:10}.st43{fill:none;stroke:#75d1c6;stroke-linecap:round;stroke-linejoin:round}.st48{fill:#564444}.st49{fill:none;stroke:#757575;stroke-linecap:round;stroke-linejoin:round}.st51{fill:#097263}.st57{fill:#1a1a1a}"
      }
    </style>
    <pattern
      y={1080}
      width={131}
      height={104}
      patternUnits="userSpaceOnUse"
      id="SVGID_3_"
      viewBox="0 -104 131 104"
      style={{
        overflow: "visible",
      }}
    >
      <path className="st0" d="M0-104h131V0H0z" />
      <path className="st0" d="M0-104h131V0H0z" />
      <path className="st0" d="M0-104h131V0H0z" />
      <path
        style={{
          fill: "#13a89e",
        }}
        d="M0-104h131V0H0z"
      />
    </pattern>
    <g id="Layer_2">
      <path
        d="m.3 1.3.4 1007.4L8 1002l1.5-1.3c304.5-300 495.1-232 621.9-265.1 56.3-14.7 166.5-81.4 193.9-132.4.5-1-.4 1.3.1.4 15.9-30.9 22.2-69.5 16.1-103.7C782.2 169.9 964.1 0 964.1 0"
        style={{
          fill: "#c4db7b",
        }}
      />
      <path
        d="M.7 1008.7c304.5-300 503-240 629.7-273.2 56.3-14.7 166.5-81.4 193.9-132.4.5-1-.4 1.3.1.4 15.9-30.9 22.2-69.5 16.1-103.7C782.9 178.8 954.9 8.8 964.1 0c-10.5 8.8-205.8 174.4-182.6 483.8 2.3 28.5-3.2 57.1-15.8 82.8-19.3 38.7-59.9 87.6-145.3 125-26.6 11.6-55.2 17.8-84.2 18.1-65.9.9-211.1 11.4-305.2 81.6 0 0-177.9 120.6-230.3 216.4"
        style={{
          fill: "#ef6043",
        }}
      />
      <path
        d="M696.5 596.3c-.3.8-.6 1.7-.8 2.5-1.6 8.6-6 16.4-12.5 22.3-9.9 9.2-22 13.1-35.2 13.1H239.8c-2.4 0-4.7.1-7.1 0-11.5-.5-18.8-7.5-18.8-18.6-.1-20.1 0-40.2 0-60.3-.1-1.1-.1-2.3-.2-3.4h-4.2l-.2 3.4c0 20.6.2 41.1 0 61.7-.1 8.6-4.5 14-12.6 16.1-2.9.8-5.8 1.2-8.8 1.3-62.6 0-125.1.1-187.7 0v2.6h496.4c55.1 0 110.2.2 165.3-.1 20.1-.1 31.7-8.6 34.3-29.9.5-3.4 2.1-7.1.3-10.7z"
        style={{
          fill: "#939fa5",
        }}
      />
      <path
        className="st5"
        d="M196.4 526.5c-11.5-7.5-24.8-10.3-38.3-11-14.5-.7-29-.2-43.5-.2-2.1 0-4.2.4-4.5 2.6-.6 3.6-3.5 3.9-5.9 4.3-4.7.7-9.4.7-14.1 1.1-7.1.7-14.1 1.3-21.1 2.2-11.7 1.5-23.3 3.2-34.9 4.9-11.3 1.6-22.5 3.2-33.8 5.1v19.9h209l.2-3.4c1.3-11.5-4.3-19.7-13.1-25.5zM661.8 351.2c-2.8-2.6-6.3-3.9-9.8-5.3H.2V369H668c.5-6.8-.6-13.1-6.2-17.8z"
      />
      <path className="st6" d="M.2 393.3h60v90H.2z" />
      <path className="st7" d="M318.2 412.3h98v67h-98z" />
      <path
        className="st8"
        d="M654.2 369H.2v41.7c14.2-.7 28.2-2.9 42.2-4.9 15.2-2.1 30.4-4.4 45.5-7.5 5.2-1.1 7.4.5 7.9 6 1.7 15.8 3 31.8 4.8 47.6 2 17.2 5.4 34.1 8.8 51 .3 1.9.5 3.8.5 5.7.2 4-1.8 5.9-5.8 6.3-29.5 2.6-58.8 6.2-88 11-5.4.9-10.7 1.7-16.1 2.6v7c11.3-1.8 22.6-3.4 33.9-5.1 11.6-1.7 23.3-3.4 34.9-4.9 7-.9 14.1-1.6 21.1-2.2 4.7-.4 9.4-.4 14.1-1.1 2.4-.4 5.3-.6 5.9-4.3.4-2.2 2.5-2.6 4.5-2.6 14.5 0 29-.5 43.5.2 13.5.7 26.8 3.6 38.3 11 8.8 5.7 14.4 13.9 13.1 25.3h4.2c-.9-6.8 1.2-13.7 5.6-19 4.1-5 9.6-8.3 15.5-10.6 10.5-4.1 21.3-6.9 32.7-6.9h144.9c1.9 0 3.8-.1 5.8-.1 1.5-19.1 2.1-38.3 1.7-57.5-.4-11.6-1.5-23.2-2.4-34.8-.1-3.7.2-7.4 1-11 .5-2.9 2.8-3.4 5.5-3.3 10.3.4 20.7.8 31 .9 19.2.1 38.5.2 57.7-.1 7.4-.1 14.8-.8 22.2-.8 1.9-.1 3.8.3 5.6 1.1.2-4.9 1.2-9.7 2.9-14.2 1.4-3.7 4-4.5 7.4-3.6 15.1 4 30.1 8.3 45.2 12 14.3 3.6 28.6 7.2 43 10.1 6.2 1.2 12.4 2.5 18.6 3.5h.3c3.4.7 5.6 4 4.9 7.5-1 4.7-2 9.5-4.1 13.9-3 10.9-6.1 21.8-8.9 32.7-4.3 16.8-7.5 33.9-10.6 51-.3 1.8-1.3 3.3-1.6 5-.8 4.5-3.5 5.2-7.5 4.1-11.7-3.3-23.3-6.6-35-9.6-14.3-3.6-28.7-6.8-43-10.2-3.6-.8-7.2-1.5-10.8-2.3-.4 2.2-.6 4.5.6 6.5 7.9.6 15.5 2.8 23.2 4.7 6.7 1.6 13.5 3 20.2 4.7 14.9 3.9 29.8 8.1 44.7 12.1 4.8 1.3 6.4.2 8.1-4.7 1-2.9 2.5-5.7 2.6-8.9.1-2.4 1.6-2.6 3.8-2.1 5.5 1.2 10.3 4.2 15.7 5.7.9-15.6 1.8-31.3 2.6-47 .4-7.3.6-14.7.9-22-.6-15.3 2.9-30.4 1.9-45.6-.1-.9.2-1.8.8-2.4l.3-13.3c-.2-1.5-.7-3.1.6-4.4l.2-8.9v-1.8c.2-4.4.4-8.9.6-13.3l-13.7.1zm-420.4 75.3c-3.7 1.3-7.6 1-11.4 1-7 0-10.5 3.4-10.4 10.2.2 3.5-.2 7.1-1.2 10.5-.3.8-.5 1.9-1.6 1.9-1.4 0-1.6-1.2-1.7-2.2-.2-3.7.4-7.4-.6-10.7.2-5.6-3.6-9.6-9-9.8-4.1-.1-8.3.6-12.3-.8-.8-.3-1.9-.2-1.9-1.4s1-1.3 1.9-1.3c2.9-.2 5.8-1.5 8.8-.9 5.2 1.1 8.8-1.2 12-4.9.8-1 1.2-2.4 1-3.7v-11.1c0-1.3 0-3 1.8-3 1.5 0 1.7 1.4 1.7 2.6.2 2.9 1.1 5.8 1 8.8-.2 8.3 2.9 11.2 11.1 11.2 3.5 0 7.1-.1 10.5.9.7.2 1.6-.1 1.8.9.3 1.3-.6 1.5-1.5 1.8zm160.5.1c-4.2 1.4-8.5.8-12.8.9-4.4.1-8.6 4.1-8.6 8.5.1 4.1-.2 8.2-.9 12.3-.2 1.1-.1 2.7-1.7 2.6-1.4-.1-1.7-1.6-1.8-2.7-.3-3.9-.4-7.9-.2-11.8.3-4.3-4.4-8.7-8.7-8.9-4-.2-8 .6-11.9-.8-.9-.3-2.3-.1-2.2-1.6.1-1.2 1.2-1.7 2.2-1.8 2.5-.3 5-.3 8.1-.4 4.8 1.9 8.1-1.4 11.4-4.7 1.1-1.1 1.1-2.4 1.1-3.7.1-4 0-8 .1-12 0-1.3 0-3.1 1.8-3s1.6 1.8 1.7 3.1c.3 3.2.8 6.4.8 9.7.1 7.8 3.1 10.8 10.9 10.8 3.5 0 7.1-.3 10.5.9.7.3 1.5.5 1.5 1.4.2.8-.6 1-1.3 1.2z"
      />
      <path
        className="st9"
        d="M209.3 555.4H.3v79H188c3-.1 5.9-.5 8.8-1.3 8.1-2.1 12.5-7.5 12.6-16.1.1-20.5-.1-41.1-.1-61.6z"
      />
      <path
        className="st10"
        d="M755.2 448.9c-.9 0-1.7-.7-1.8-1.7-15.2-6.8-30.7-4.2-46.2-1-.9 9.8-1.8 19.6-2.7 29.3-1.1 12.5-2.6 25.1-3.4 37.7-.8 12-2.7 24-2.9 36 0 3.6-.6 7.3-1.8 10.7v36.5c1.8 3.6.1 7.3-.3 10.7-2.6 21.3-14.1 29.7-34.3 29.9-55.1.4-110.2.1-165.3.1H1.1v56.8h330.8c1.4 0 3 .1 4.4.1 48.2-.1 96.4-.1 144.5-.1 9.9 0 19.8.1 29.7.1h136c6.9-.5 13.8.2 20.8-.5 9.5-1.1 18.7-3.4 28.1-5 .6-.4 1.3-.7 1.9-1 20.3-7.8 35.3-21.1 44.2-41.2 3.2-7.3 4.7-15 7-22.5 2.1-24.8 4.3-49.7 6.4-74.5.2-1.9.6-3.8.6-5.7.5-14.5 2.3-29 3.1-43.5.3-5.2-.3-10.6 1.4-15.6 0-1.8.1-3.5.1-5.3.6-10.6 1.3-21.1-4.9-30.3z"
      />
      <path
        d="M658.3 763c.2 2.3.5 4.6 1 6.9.9 3-.1 3.5-3 3.9-7.2.9-12.5-.9-15.4-8-.7-1.3-1.4-2.5-2.3-3.7l-20.5-31c-1.5-2.2-2.8-4.5-4.4-6.6-7.2-9.8-14.5-19.5-19.7-30.6h52.7c2 11.2 3.9 22.5 5.9 33.7 1.3 11.9 3.6 23.7 5.7 35.4z"
        style={{
          fill: "#8e4910",
        }}
      />
      <path
        className="st9"
        d="M696.5 559.8v36.5c-.3.8-.6 1.7-.8 2.5-1.6 8.6-6 16.4-12.5 22.3-9.9 9.2-22 13.1-35.2 13.1-136.1.1-272.1.1-408.2 0-2.4 0-4.7.1-7.1 0-11.5-.5-18.8-7.5-18.8-18.6-.1-20.1 0-40.2.1-60.3h480l2.5 4.5z"
      />
      <path
        className="st12"
        d="m696.5 559.8-2.6-4.5c-.6-2.9-2.2-5.1-4.1-7.2-8.2-9.2-18.8-15-29.7-20.4.9-15.7 1.8-31.4 2.6-47 .4-7.3.6-14.7.9-22 4.8-.2 8.9-2.8 13.4-4.2 10-3 19.8-6.5 30.2-8.4-.9 9.8-1.8 19.6-2.7 29.3-1.1 12.5-2.6 25.1-3.4 37.6-.8 12-2.7 23.9-2.9 36 .1 3.8-.5 7.4-1.7 10.8z"
      />
      <path
        className="st5"
        d="M213.9 555.3c-.1-1.1-.1-2.3-.2-3.4-.9-6.8 1.2-13.7 5.6-19 4.1-5 9.6-8.3 15.5-10.6 10.5-4.1 21.3-6.9 32.7-6.9h144.9c1.9 0 3.9-.1 5.8-.1.4 3-1.5 6 .1 9-1.3 4.2.5 7 4.7 7.1 7.5.1 15-.5 22.5-.7 23.1-.4 46.1-.4 69.2 0 7 .1 14.1.7 21.2.7 4.5 0 6.4-2.8 5-7.2-.3-2.7.6-5.3 1-8 7.9.6 15.5 2.8 23.2 4.7 6.7 1.6 13.5 3 20.2 4.7 14.9 3.9 29.8 8.1 44.7 12.1 4.8 1.3 6.4.2 8.1-4.7 1-2.9 2.5-5.7 2.6-8.9.1-2.4 1.6-2.6 3.8-2.1 5.5 1.2 10.3 4.2 15.7 5.7 10.9 5.4 21.4 11.2 29.7 20.4 1.9 2.1 3.5 4.3 4.1 7.2H213.9z"
      />
      <path
        className="st6"
        d="M418.2 524.3c-1.7-3 .3-6-.1-9 1.5-19.1 2.1-38.3 1.7-57.5-.3-11.6-1.5-23.2-2.4-34.8-.1-3.7.2-7.4 1-11 .5-2.9 2.8-3.4 5.5-3.3 10.3.4 20.7.8 31 .9 19.2.1 38.5.2 57.7-.1 7.4-.1 14.8-.8 22.2-.8 1.9-.1 3.8.3 5.6 1.1.2.9.3 1.8.5 2.6-1.4 2.8-1.4 6.1.1 8.9 0 2.6.3 5.3-.4 7.9-2 .8-4.1 2.3-6.1 2.3-10.4-.3-18.8 5.3-27.6 9.3-5.8 2.6-10.6 7.1-16.4 9.8-1.9.9-3.5 2.1-5 3.6-7.6 7.4-14.9 15-22.6 22.4-3.3 3.2-5.2 7.2-8.2 10.6-4.7 5.4-8 11.8-11.3 18.1-3.4 6.5-9 12.1-9 20.1-5.5.8-11 2.1-16.2-1.1z"
      />
      <path
        d="M434.3 525.3c0-8 5.6-13.6 9-20.1 3.3-6.3 6.6-12.6 11.3-18.1 3-3.4 4.9-7.4 8.2-10.6 7.6-7.3 15-15 22.6-22.4 1.5-1.5 3.1-2.7 5-3.6 5.8-2.7 10.6-7.2 16.4-9.8 8.9-4 17.2-9.6 27.6-9.3 2 .1 4.1-1.5 6.1-2.3.9 3.3-.5 6.4-.5 9.7 0 7.7-.1 15.4-.3 23-.3 11.3.1 22.7.7 34-.5 2.4.4 4.7.5 7.1l.1 1.7.2 5.1c-.4 2.2-.6 4.4.6 6.5-.4 2.7-1.3 5.2-1 8-1.6 1.4-3.6 2-5.7 1.9-4.6.1-9.1-.8-13.7-.8h-87.1z"
        style={{
          fill: "#f8f5cf",
        }}
      />
      <path
        className="st12"
        d="M207 455c.2-5.6-3.6-9.6-8.9-9.8-4.1-.1-8.3.6-12.3-.8-.8-.3-1.9-.2-1.9-1.4s1-1.3 1.9-1.3c2.9-.2 5.8-1.5 8.8-.9 5.2 1.1 8.8-1.2 12-4.9.8-1 1.2-2.4 1.1-3.7v-11.1c0-1.3 0-3 1.8-3 1.5 0 1.6 1.4 1.7 2.6.2 2.9 1 5.8 1 8.8-.2 8.3 2.9 11.3 11.1 11.2 3.5 0 7.1-.1 10.5.9.7.2 1.6 0 1.8.9.2 1.1-.8 1.4-1.6 1.7-3.7 1.2-7.6 1-11.4 1-7 0-10.5 3.4-10.4 10.2.2 3.5-.2 7.1-1.2 10.5-.3.8-.5 1.9-1.6 1.9-1.4 0-1.6-1.1-1.6-2.2-.4-3.6.2-7.3-.8-10.6z"
      />
      <path
        className="st10"
        d="M434.3 525.3c29.1 0 58.2-.1 87.3 0 4.5 0 9.1.9 13.7.8 2.1.1 4.1-.6 5.7-1.9 1.4 4.4-.5 7.2-5 7.2-7.1 0-14.2-.6-21.2-.7-23.1-.4-46.1-.4-69.2 0-7.5.2-15 .8-22.5.7-4.2 0-6-2.9-4.7-7.1 5 3.2 10.5 1.9 15.9 1z"
      />
      <path
        d="M541 503c.8.5.9 1.1.1 1.7l-.1-1.7z"
        style={{
          fill: "#ebb452",
        }}
      />
      <path
        className="st15"
        d="M167.1 552.7c-4.5 4-15.7 8.2-22 17.1-6.7 9.6 4.2 57.7-1.7 61.8-12.4 8.5-12.4-33.9-20.5-42.3-12.3-12.8-19.6-19.3-17.9-26.1 1.7-6.6 9.9-5.6 22.9-16.1 13.4-10.9 18.8-16.6 21.5-18.8l8.4 11.5 9.3 12.9z"
      />
      <path
        className="st16"
        d="m100.3 561.7 7.5-4.9c2.3-1.5 4.8-2.7 7.4-3.6l5.5-1.8.8-.3c1.1-.4 2.4.3 2.7 1.4.1.4.1.8 0 1.3l-.5 1.9c-1.4 8 4 15.7 12.1 17.1l2.2-2.2c2.1-2.1 5.2-2.8 8-1.9 1 .4 1.6 1.4 1.6 2.4 0 0-1.3 16.1-1.3 16.3 0 .1 0 .5-.1.6s0 .5-.1.7 0 .3 0 .4v.1c0 .2-.2 6-.2 6.1s.1 3.3.1 3.5v1.3c0 .5.1 1 .1 1.5v.3c0 .1.5 3.7.6 4.4v.2c.1.3.2.9.2 1 0 .3.2.8.2.9.2.9.6 2.7.6 2.8.1.3.1.5.2.8v.2l.2.8c.7 2.6 1.5 5.2 2.5 7.8l3.9 10.1c1.7 4.4.1 9.3-3.8 11.9h-.1l-.3.2c-1.9 1.1-3.9 1.7-6.1 1.9l-.2.1v-.1c-4.4.3-8.7-1.7-11.4-5.2-.2-.2-.4-.5-.6-.8l-40.2-61.6c-2.3-3.5-2.1-7.4.9-10.1.4-.4 1.3-.7 1.6-.3l2.6-2.5c1.1-1 2.2-1.9 3.4-2.7z"
      />
      <path
        className="st17"
        d="M424.9 590.8c-3.5 4.9-6.6 16.5-14.9 23.6-8.9 7.6-57.9 1.5-61.3 7.8-7.2 13.1 31.4 11.8 40.5 19.1 13.9 11 24.7 14.8 31.3 12.4 6.4-2.3 4.6-10.4 13.8-24.3 9.5-14.4 14.7-20.4 16.5-23.2l-12.3-7.3-13.6-8.1zM463.2 644.7c-.6 6 2.6 17.5-1 27.9-3.8 11-49.3 30.3-49.1 37.5.4 15 33.1-5.5 44.6-3.8 17.6 2.6 28.8.4 33.3-5s-1.3-11.3-.3-28c1-17.2 2.5-25 2.7-28.4l-14.3-.1-15.9-.1z"
      />
      <path
        className="st15"
        d="M248.2 554.5c.2 6-3.6 17.4-.6 27.9 3.2 11.2 48.2 27.1 47.6 34.2-1.3 14.9-34.9-5.7-46.5-4.7-17.7 1.5-27.3 3-31.5-2.6-4.1-5.5 1.9-11.2 2-27.9 0-17.3-1-25.1-1-28.5l30 1.6z"
      />
      <path
        className="st16"
        d="m212.6 608.5.8-9c.2-2.7.9-5.4 1.8-8l2-5.4.3-.8c.4-1.1 1.6-1.7 2.8-1.3.4.2.8.4 1 .8l1.1 1.6c5.5 6.1 14.8 6.6 20.9 1.2l-.4-3.1c-.4-3 1-5.9 3.5-7.5.9-.6 2.1-.4 2.9.3l12 11.2.4.4.5.5.3.3h.1c.1.1 4.6 3.8 4.7 3.9l2.8 2 .3.2.5.4.2.1c.4.3.8.5 1.2.8l.2.2c.2.1 3.2 1.9 3.8 2.3l.2.1c.2.1.8.5.9.5l.8.4c.8.4 2.5 1.2 2.5 1.2l.7.3.2.1.8.3c2.5 1.1 5.1 2.1 7.7 2.9l10.3 3.2c4.5 1.4 7.4 5.7 7 10.4v.1l-.1.4c-.3 2.1-1.1 4.2-2.3 5.9l-.1.2h-.1c-2.5 3.6-6.7 5.8-11.1 5.7l-1-.1-73.3-6.6c-4.2-.4-7.1-2.9-7.4-7 0-.6.2-1.4.8-1.5l-.3-3.6c0-1.2 0-2.6.1-4z"
      />
      <ellipse
        transform="rotate(-30 640.388 281.335)"
        className="st18"
        cx={640.4}
        cy={281.3}
        rx={13.3}
        ry={18.5}
      />
      <ellipse
        transform="rotate(-77.561 692.312 278.872)"
        className="st18"
        cx={692.3}
        cy={278.9}
        rx={15.9}
        ry={10.2}
      />
      <path
        className="st19"
        d="M392.3 181.6s11.1 8.8 16.2-2.9-.2-19.7-7.7-20.2-18.1 11.1-14.8 16.3 6.3 6.8 6.3 6.8z"
      />
      <path
        className="st20"
        d="M433.8 158.8c-31-4.5-45.3 15.2-38.4 41.8 5.3 20.3 16.8 36.9 37.8 36.9 9.6 0 20.8-6.5 20.8-6.5 7.1 7 24.8-17.6 16.8-42.4-5-16-15.9-26.7-37-29.8z"
      />
      <path
        className="st21"
        d="M351 346.4c-11.6-6.8 16-75.7 29.5-90.2 8.6-9.3 17.4-9.3 30.5-13.9 9.8-3.5 28.6-1 38.8-.9 22.4.3 47.6 5.2 57.3 16.4 11.3 13.1 1.4 40 4.7 63.2 1.7 11.6 1 21.6-.8 25.5H351v-.1z"
      />
      <path
        className="st21"
        d="m453.9 250.8-2.8-13c2.3-1.8 10.5-16.1 10.8-26.2.8-21.6-11.2-41-28.5-43.2-19.9-2.5-32 12.7-35.3 34.1s7 42.2 24.1 44.9l1.8 9.6c1.5 8.2 9.3 13.7 17.5 12.4l.4-.1c8.3-1.6 13.7-9.7 12.1-18-.1-.3-.1-.4-.1-.5z"
      />
      <g className="st22">
        <path
          className="st23"
          d="M414.1 214.4c-.2.9-.5 1.8-.8 2.6-.2.6-.4 1.2-.5 1.9-.1.4 0 .8.2 1.2.4.4.9.5 1.4.5.8-.1 1.5-.5 1.9-1.2.1-.1 0-.2-.1-.3s-.2 0-.3.1c-.4.7-1.1 1.1-1.9 1-.5-.1-.9-.3-.9-.8.1-.6.2-1.3.5-1.9.3-.9.6-1.9.9-2.9.1-.3-.3-.5-.4-.2z"
        />
      </g>
      <path
        className="st24"
        d="m423.2 252.3-1-5C439.4 246 446 236 446 236c-4.9 8.4-9.8 16.3-22.8 16.3z"
      />
      <path
        d="M460.8 213.7c-.5 4-4.1 6.9-8.1 6.4s-6.9-4.1-6.4-8.1 4.1-6.9 8.1-6.4 6.9 4.1 6.4 8.1z"
        style={{
          fill: "#ffa18a",
        }}
      />
      <path
        className="st26"
        d="M456.2 210.7c-.8.4-1.6 1-2.1 1.7-.5.9-.8 1.9-.8 3 0 .5-.9.6-.8 0 0-1.2.4-2.4 1-3.4.6-.9 1.5-1.6 2.5-2.1.2-.1.4 0 .5.3.1.2 0 .4-.3.5.1 0 .1 0 0 0z"
      />
      <path
        className="st26"
        d="M453.7 212.1c.9 0 1.7.4 2.2 1.1.3.6.3 1.4 0 2-.2.4-.4.7-.8.9-.2.1-.5.1-.6-.1-.1-.2 0-.4.1-.5l.1-.1.1-.1.1-.1s.1-.1 0 0l.1-.2.1-.2v-.5c0-.1 0 0 0 0v-.4c0-.1 0 .1 0 0v-.1c0-.1 0-.1-.1-.2v-.1s0-.1-.1-.1c0 0 .1.1 0 0l-.1-.1-.1-.1s.1 0 0 0c-.1-.1-.2-.1-.2-.1l-.1-.1c-.1 0 0 0 0 0h-.1l-.3-.1H453.7c-.2 0-.4-.3-.4-.5s.2-.3.4-.4v.1z"
      />
      <path
        d="M443.1 325.3c8-1.5 15.9-3.3 23.8-5.2 4-.9 7.9-1.9 11.9-2.7 3.8-1 7.8-1.5 11.8-1.5 4.2 0 8.3 1.2 11.8 3.6.4.3.8-.4.4-.6-6.1-4.4-13.9-4.1-21-2.8-8.3 1.6-16.5 3.8-24.7 5.7-4.7 1.1-9.4 2.1-14.2 3-.5-.1-.3.6.2.5z"
        style={{
          fill: "#8e5a50",
        }}
      />
      <g className="st22">
        <path
          className="st23"
          d="M382 255.3c4.9 3.7 8.6 8.6 10.8 14.3 1.8 5.1 2.5 10.5 2.2 16-.4 10.2-3.5 20-4.7 30.1-.5 4-.6 8.4 1.3 12 .2.4.9 0 .6-.4-1.8-3.3-1.7-7.4-1.3-11 .5-4.9 1.6-9.7 2.5-14.5 2-10.2 3.8-21.2.4-31.4-2.2-6.2-6.1-11.6-11.3-15.6-.4-.3-.9.2-.5.5z"
        />
      </g>
      <path
        d="M173.3 314.5c19.1-11.5 66.3-32.7 133.1-16 5.4 1.3 9.8 5.1 11.9 10.3 6.8 17.7 22.3 61.8 23.8 100.3.2 6-4 11.2-9.8 12.3-27.6 5.7-101.7 25.5-111.1 28.4-16.2 5-36.7-91.6-52-121.1-2.7-5.1-.9-11.4 4.1-14.2z"
        style={{
          fill: "#93529e",
        }}
      />
      <path
        className="st29"
        d="M297.4 320.5s36.6 33.8 0 65.2M308.7 317.2s.9 4.6 0 7"
      />
      <path className="st30" d="M306.7 399.8s-1.3 19.6-75.8 41.9" />
      <path
        d="M205 427.1s-1.7-23.3 1.4-32.3"
        style={{
          fill: "none",
          stroke: "#7c4b87",
          strokeMiterlimit: 10,
        }}
      />
      <path className="st30" d="M178.8 330.5s22.6 26.7 26.7 52.8" />
      <path
        d="M570.9 374.9c-1.4-3.2-4.1-5.7-7.5-6.9-2.2-.8-4.5-.9-6.8-.4l.3-2.8h-46.6l5 41.5 37.3.5 1.7-15.3c2.6.5 5.4.4 8-.1 3.7-.7 7-2.7 8.6-6.2 1.5-3.3 1.5-7 0-10.3zm-3.7 6s-.1.5-.1.6c-.1.4-.2.8-.3 1.1l-.1.2-.2.3c-.1.3-.3.5-.5.8l-.3.4c.1-.1.3-.3 0 .1s-.5.5-.7.8l-.2.2-.1.1c-.3.2-.7.4-1 .5-.2.1-.5.2-.7.3-.4.1-.8.2-1.2.4-2.3.5-4.7.6-7 .1l1.4-14 .5-.2 1.2-.3c1.1-.2 2.2-.2 3.3.1.3.1.6.2 1 .3l.3.1.3.1c.3.1.5.3.8.5l.4.2.2.2c.5.4.9.8 1.3 1.2l.2.3.1.2c.2.3.4.6.6 1 .1.2.3.5.4.7 0 0 .2.5.2.6.1.3.2.6.2.9l.1.3v.3c0 .5 0 1-.1 1.6z"
        style={{
          fill: "#fcfbf0",
        }}
      />
      <path
        d="M554.4 392.4c-.1 1.2-.2 2.5-.3 3.7l-.1.5c0 .3.5.3.5 0l.4-3.7v-.5c0-.1-.5-.3-.5 0z"
        style={{
          fill: "#d8d8d8",
        }}
      />
      <path
        className="st20"
        d="M409.1 176.7c4.5 8.3 25.7 10.4 44.6 34.5 1.9 2.5 5.6-2.3 8-5.4 5.5-7-2.4-28.6-18.4-36.3-14.2-6.9-37.5 1.1-34.2 7.2z"
      />
      <path
        className="st19"
        d="M448.6 164.5s4.3-13.4 15.1-6.7 10.8 16.5 4.9 21.1-21.2.9-21.3-5.2 1.3-9.2 1.3-9.2z"
      />
      <path
        className="st20"
        d="M442.2 203.6s1.1 43.1-2.1 57.6c.3-.5 3.6 0 3.6 0s6.9-30.4 6.3-39.3c1.1 1.1 1.9 7.7 2.9 10.8s9-2.1 9-2.1 7.5-50.1-16.4-59.7-3.3 32.7-3.3 32.7z"
      />
      <path
        className="st20"
        d="M466.9 180.2s9.7 15.9 7.1 39.6c-.2 2.4-1.4 4.6-3.2 6.1l-16 13.8-9.7-12 3-23.4 18.8-24.1zM403.1 175.7s9.4 13.7 18.9 15.5 15.6 20.1 15.6 20.1l3.1-20.1-15.8-15-21.8-.5z"
      />
      <path
        d="M65.4 465c-9.6 3.5-18.4 8.9-25.8 15.8-.4.4.2 1 .6.6 7.3-6.8 16-12.1 25.4-15.6.6-.2.3-1-.2-.8z"
        style={{
          fill: "#acadad",
        }}
      />
      <path
        className="st15"
        d="M124.5 370.6c1-23 29.4-29.7 29.4-29.7 5.2 5.4 17.6 28.6 36.1 35.6 5.9 2.3 75.6-24.9 86.6-30.8 6.8-3.7 19.3-14.2 34.3-13 18.1 1.5 14.4 32.9 1.4 34.9-11.2 1.7-12.5-7.5-20.4-4.5"
      />
      <path
        className="st7"
        d="M648.5 277.7c-3.4.5-5.8-.6-6.7-1.6-.1-.1-.1-.3 0-.4l.1-.1s3.7-.3 6.1-.7 6.1-1.2 6.1-1.2c.2 0 .3 0 .3.3-.5 1.3-2.3 3.2-5.9 3.7z"
      />
      <path
        style={{
          fill: "#ea8f7d",
        }}
        d="m616.3 360.2 14.1 3.3-33.6 101-7-5.5z"
      />
      <pattern
        id="SVGID_1_"
        xlinkHref="#SVGID_3_"
        patternTransform="translate(-1942.75 18287.29)"
      />
      <path
        d="M410.2 604.3s32.5 17.9 43 17l22.5-50.6-20.5 88.6s18.8 7.5 22 8c5.6.9 20-1 20-1 26-75 39.8-146.8 45-150s43.8 33.8 79.1 34.2c42.2.5 62.1-23.6 60.5-52.6-.9-16-89-37.3-89-37.3-49.4-26.2-63-45.6-85.4-43-41.1 4.7-60.2 128.7-97.2 186.7z"
        style={{
          fill: "url(#SVGID_1_)",
        }}
      />
      <path
        className="st37"
        d="M590.2 458.3s23.8 18.2 38 22c33.5 8.9 46.9 23.9 52 32.5.8 1.3 2.5 1.7 3.8.9.5-.3.9-.8 1.2-1.4 9.9-27.5 47.4-93.5 42.1-128.3l13.3 4.4c6.6-15 13.6-32 6.6-44s-25.1-22-47.6-25.4c-7.4-1.1-29.4-1.2-36.8-1.5-9.1-.4-18.3.4-27.2 2.5-26.6 5.6-29.3 31.2-35.1 51.2-.6 2.1 13.7 5.6 13.7 5.6-.1 11.5-6.7 21-8.1 32.5-2.1 18.9-5.7 33.8-15.9 49z"
      />
      <path
        className="st17"
        d="m692.2 313.5.5-44.6c2.1-4.8 3.2-10 3.3-15.2.3-22.1-19.8-42.3-37.6-42-20.5.4-32.7 17.6-30.8 39.6 1.9 22 12.8 46.3 30.6 46.5 1.4 0-.4.2 1 0v19.4c-.1.1 22.8 6.7 33-3.7z"
      />
      <circle className="st17" cx={686} cy={258.2} r={7.5} />
      <path
        className="st38"
        d="M688.8 255.9c-.9.3-1.7.9-2.2 1.6-.6.9-.9 1.9-1 3-.1.5-.9.5-.8 0 .1-1.2.5-2.4 1.2-3.5.7-.9 1.6-1.6 2.7-2 .2-.1.5.1.5.3 0 .4-.1.6-.4.6z"
      />
      <path
        className="st38"
        d="M686.2 257.2c.9 0 1.7.5 2.2 1.3.3.7.3 1.4-.1 2.1-.2.4-.5.7-.8.9-.2.1-.5 0-.6-.2s0-.5.2-.6c0 0 .1-.1 0 0l.1-.1.2-.1.1-.1s.1-.1 0 0c0-.1.1-.1.1-.2l.1-.2s0-.1 0 0v-.5c0-.1 0 0 0 0v-.4c0-.1 0 .1 0 0v-.1c0-.1 0-.1-.1-.2 0 .1 0 0 0 0v-.1l-.1-.1s.1.1 0 0l-.2-.2-.1-.1s.1 0 0 0l-.2-.2-.1-.1c-.1 0 0 0 0 0h-.2c-.1 0-.2-.1-.3-.1h-.4c-.2 0-.4-.2-.4-.4s.2-.4.4-.4l.2.1z"
      />
      <path
        d="M659.2 304v-6.1c20.4 3.1 33.7-20.4 33.7-20.4-2.4 12.6-16.8 24-33.7 26.5z"
        style={{
          opacity: 0.3,
          fill: "#9e6352",
          enableBackground: "new",
        }}
      />
      <path
        d="M476 571.3c11-18.7 20.4-38.3 27.9-58.6 2.2-5.9 4.2-11.9 6-17.9.1-.3-.1-.7-.4-.8-.3-.1-.7.1-.8.4-6.4 20.7-14.6 40.8-24.7 60-2.9 5.5-5.9 10.9-9.1 16.3-.1.3 0 .7.3.8.3.1.6 0 .8-.2z"
        style={{
          fill: "#75d1c6",
        }}
      />
      <path
        className="st15"
        d="m157.4 272.4-1.4 23.4c-1.1 6.9 0 5.8-2.3 21.9-9.4-2.1-19.1-2.9-28.8-2.3-27.1 1.4-19.2-14.7-19.2-14.7l5.1-1.4c5.7-1.4 9.6-6.7 9.4-12.5l-1-20.4 38.2 6z"
      />
      <path
        className="st24"
        d="M119.7 279.3c8.8 7.2 24 14.7 37.4 4.9l.4-6.3-38.2-8.5.4 9.9z"
      />
      <path
        className="st15"
        d="M111.5 261.5s8.9-.4 11.4-8.5c0-.1 11-44.4 26.6-44.6 18.5-.2 26.4 5.5 28.3 23.6.8 7.7 4.5 10.6 8.1 14.4.9 1 .7 2.5-.3 3.4-.5.4-1.2.6-1.9.5l-2.7-.1c-.6 0-1.1.4-1.2 1.1-.8 10.3-5.6 24.6-8.8 27.1-2 1.6-9.7 3.9-16.9 4.4-27.6 1.6-42.6-21.3-42.6-21.3z"
      />
      <path
        className="st37"
        d="M99.6 196.4c7.4-10.5 20.4-15.2 37-13.3 0 0 18.2 3 25 3.2.2 0 5.4 22.2 5.4 22.2-4.3 1.8-8.3 4.3-11.8 7.4-4.8 4.3-8 13.6-8.5 18.3-.2 1.6-.3 3.8-.3 5.3v.3c-4.1 6.4-7.1.3-7.2.3v-2.8c0-.1-7.5 3.1-8.1 7.6-1.7 13.4-12.6 26-19.3 26-14.8 0-13.5-21.1-20.2-38.5-5.3-13.9.5-25.6 8-36z"
      />
      <path
        className="st15"
        d="M124.5 240.5c.7 3.9 4.4 6.5 8.3 5.9h.1c4-.6 6.8-4.2 6.4-8.2-.3-4.3-3.6-7.6-7.4-7.3-7 .5-8.1 5.5-7.4 9.6z"
      />
      <path
        className="st24"
        d="M130.4 239.1c.1-.7.6-1.2 1.2-1.4.3-.1.7-.1 1-.1-.3-.8-.9-1.4-1.6-1.9-.3-.2 0-.8.3-.6.9.6 1.5 1.4 1.9 2.4.4 1.1.4 2.2.2 3.3-.1.4-.7.2-.6-.2.2-.8.2-1.6 0-2.4H132.2c-.1 0-.2 0-.2.1h-.1c-.1 0-.1.1-.2.1h-.1c-.1 0-.1.1-.1.1v.1c0 .1-.1.1-.1.2v.1c0 .1 0 .1-.1.2v.6c0 .1 0 .1.1.2v.2l.1.2.1.1.1.1c.1.1.1.3 0 .5-.1.1-.3.1-.5 0-.5-.8-.8-1.3-.8-1.9z"
      />
      <path
        d="M172.6 207.8c5.4-3.5 8.7-8.9 7.9-16.2-.5-4.6-1.1-11.2-7.9-12.9-2.8-.7-13.4-10.6-21.7-9.3-7.5 1.2-11.9 6.1-19.9 8-12.3 3-18.5 7.1-19 11.6s2.1 8.4-1.1 14.1c-3.6 6.6-7 7.6-8.4 12.9-.8 2.8 1.1 3.1 4.7 12.6 2.7 7.1 1 12.1 3.4 13.2 4.8 2.2 7.7-4.3 12-5.2 5.7-1.2 10.2-4.1 10.6-4.7 3.1-4.4-2.1-9.4.5-12.2 2.9-3 9.8 2.8 19.6.3 6-1.5 13.6-1.4 15.3-2.9 5.6-5 .5-7 4-9.3z"
        style={{
          fill: "#02594f",
        }}
      />
      <path
        className="st17"
        d="M698.9 381.9c-4.8 5-16.3 26.4-33.3 32.9-5.5 2.1-69.9-23-80.1-28.5-6.3-3.4-17.9-13.2-31.7-12.1-16.8 1.3-13.3 30.4-1.3 32.3 10.3 1.6 11.6-7 18.8-4.1 37.5 14.5 80.6 48.4 97.2 48.4 18.2 0 57.6-41.5 57.6-41.5-1-21.2-27.2-27.4-27.2-27.4z"
      />
      <path
        className="st37"
        d="m744.2 380-15.9 37.4s-22.6-12.3-35.4-27.7-2.2-.5-2.2-.5l15.5-24 38 14.8"
      />
      <path
        className="st42"
        d="M706.2 365.3s-7.6 16.8-13.3 24.4M616.3 360.2l-2 16.5M654.6 335.7s30.4 6.1 49.8-5.4M691.7 468.7s-7.9 15-18.9 15"
      />
      <path
        className="st43"
        d="M510 485.9s18.2 19.5 31 26.2M419.7 594.5s12.7 12.2 31.4 15.8M462.3 648.4s10.2 7.6 32.8 6"
      />
      <path
        className="st17"
        d="M693.9 315.9c-.6-.8-1.2-1.5-1.7-2.4l-2.9-3.2-2.1 3.2-27.9-.9v2.1c0 1.1-.9 2.1-2 2.2l-8.8.9c22.2 15.5 56 1.9 56 1.9-3.9-.1-7.6-1.5-10.6-3.8z"
      />
      <path
        d="M382.5 254.7s18.2 9.3 11 46.9c0 0-6.5 18.1-1.9 25.8 0 0 14.8 3.7 24.7 1.2l32.2-5.2 27-6 2.5-21.6s4-14.6 6.4-20.6c1.1-2.7 2-5.5 2.8-8.3 1.7-6.2 3.8-12.2 6.2-18.2-2.5-1-5-1.9-7.6-2.6 0 0-11.6 42.1-20.6 48.1 0 0-37.3 8.1-62.1 1.1 0 0-4.2-36.3-15-45.2 0 .1-4.3 2.1-5.6 4.6z"
        style={{
          fill: "#26211d",
        }}
      />
      <path
        d="M414.4 313.5c-1.8-4.1-6.2-6.4-10.6-5.4l.2-2h-34.7l2.8 25.1h29.4l.5-5.3c2 .3 4 .3 5.9-.1 2.8-.4 5.2-2.1 6.4-4.6 1.3-2.4 1.3-5.2.1-7.7zm-2.7 4.5s-.1.4-.1.5c-.1.3-.2.6-.2.8v.1l-.1.2-.3.6c-.1.1-.1.2-.2.3 0-.1.2-.2 0 0s-.4.4-.5.6l-.1.1-.2.1c-.2.1-.5.3-.7.4l-.5.2c-.3.1-.6.2-.9.2-1.7.4-3.5.4-5.2.1l1-10.4.3-.1c1.1-.4 2.2-.4 3.4-.2.2.1.5.1.7.2l.2.1.2.1.6.3.3.2.2.1c.3.3.7.6 1 .9l.2.2.1.1c.2.2.3.5.5.7l.3.6.2.5c.1.2.1.4.2.7v.4c-.4.5-.4.9-.4 1.4z"
        style={{
          fill: "#f4f4f4",
        }}
      />
      <path
        d="M367.6 346.4c-2.3-4.6.9-17.1 10-19.6 7.5-2.1 9.7-.7 22.1 2 10.2 2.2 25.7-1.9 42.8-3.9"
        style={{
          fill: "#ad6b55",
          stroke: "#8e5a50",
          strokeWidth: 0.75,
          strokeMiterlimit: 10,
        }}
      />
      <path
        className="st24"
        d="M410.9 242.3c3.4 2.3 7.3 4 11.3 5l1 5s-17.9.3-32.2-3.6c0 0 11.1-3.9 19.9-6.4z"
      />
      <path
        d="M648.1 264.4c-.1 1.2-.3 2.3-.5 3.5-.2.8-.3 1.6-.3 2.5-.1.5.1 1.1.4 1.5.5.4 1.1.6 1.7.4.9-.2 1.7-.9 2-1.8.2-.3-.3-.6-.5-.3-.3.9-1.1 1.5-2.1 1.5-.5.1-1-.3-1.1-.9v-.1c0-.8.1-1.7.2-2.5.2-1.3.5-2.5.6-3.8.1-.3-.4-.4-.4 0z"
        style={{
          fill: "#e58c7a",
        }}
      />
      <path
        className="st18"
        d="M643.3 251.6c.3-.9-.1-1.3-1.6-1.5-1.5-.1-3 .1-4.5.6-2.9 1-4.2 3.6-3.4 3.1 1.7-1 3.6-1.6 5.6-1.8 1.6-.4 3.7.2 3.9-.4zM653.5 251.1c-.6-1-.1-1.7 1.6-2.2 1.8-.5 3.6-.6 5.4-.3 3.6.6 5.6 3.5 4.5 3.1-1.8-.7-3.2-1.1-6.9-1.1-1.9.1-4.2 1.3-4.6.5z"
      />
      <ellipse className="st48" cx={656.4} cy={261.7} rx={1.2} ry={2.4} />
      <ellipse className="st48" cx={638} cy={262.7} rx={1.2} ry={2.4} />
      <path
        className="st7"
        d="M651.6 279.4c-1.5.3-3.1 0-4.3-1.1-.1-.1-.1-.2 0-.3h.1s2.4-.2 4-.4 3.9-.7 3.9-.7.2 0 .2.2c-.4.8-1.5 2-3.9 2.3z"
      />
      <path
        className="st16"
        d="m291.4 359.1-9.5-13.9c-2.6-4-7.8-5.5-12.1-3.5l-58.6 23c-4.4 2-11.9 2.3-16.1 0-9.2-5.1-13.4-8.5-16.9-13.4-1.1-1.9-2.4-4.1-3.9-6.5-7.9-12.4-22.3-31.4-48.2-56-3-2.9-7-4.7-11.1-5.2-11.5-1.3-33.6 2.2-46.2 42.3 0 0-54.5 104.8-54.4 104.6s11.5 23.6 51.2 35.2l63.5-42.7 34.4-21.6s24.7 26.5 55.6 5.6l68.3-33.2c5-2.4 7.1-8.5 4.7-13.5-.2-.3-.4-.8-.7-1.2z"
      />
      <path
        className="st49"
        d="M161.2 399.8s-33.1-19.1-41.9-36M198.8 368s-4.8 5.9-2.5 12.8"
      />
      <path
        d="M47.9 367.1s54.4 65.2 81.6 55.2l-63.9 43.6s-30.1-4.5-51.2-35.2l33.5-63.6z"
        style={{
          fill: "#b9271a",
        }}
      />
      <path
        className="st51"
        d="M112.7 222.3c2-2.4 2.3-5.5 2.8-8.5.2-1.6.7-3.2 1.3-4.7.7-1.5 1.6-3 2.7-4.3 1.9-2.6 4.4-4.8 7.2-6.4 1.7-.7 3.5-1 5.3-.9 1.8.2 3.6.1 5.4-.2 3.6-.8 6.6-3.2 9.5-5.5.5-.4-.2-1.1-.7-.7-2.6 2.1-5.3 4.3-8.6 5.1-1.8.3-3.7.4-5.6.2-1.7-.1-3.5.1-5.1.8-2.9 1.2-5.3 3.6-7.3 5.9-2.2 2.4-3.8 5.3-4.7 8.4-.8 3.3-.7 7.2-3 10-.4.6.3 1.4.8.8z"
      />
      <path
        className="st51"
        d="M135.3 203.6c-3.8.6-5.7 4.4-6.8 7.6-1.2 3.4-2.2 8-6 9.4-.6.2-.3 1.2.3 1 3.6-1.3 5.1-5 6.1-8.4 1.1-3.4 2.5-8 6.7-8.7.6-.1.4-1-.3-.9z"
      />
      <path
        d="M153.4 408c-13.2-9.4-31.5-6.3-40.9 6.9-4.7 6.6-6.5 14.9-4.9 22.8l45.8-29.7z"
        style={{
          fill: "#fffd54",
        }}
      />
      <path
        className="st8"
        d="M347.9 422.3h14.8c3.1 0 5.6 2.5 5.6 5.6v7.8c0 3.1-2.5 5.6-5.6 5.6h-14.8c-3.1 0-5.6-2.5-5.6-5.6v-7.8c-.1-3.1 2.5-5.6 5.6-5.6zM377.9 414.3h15.8c3.1 0 5.6 2.5 5.6 5.6v15.8c0 3.1-2.5 5.6-5.6 5.6h-15.8c-3.1 0-5.6-2.5-5.6-5.6v-15.8c-.1-3.1 2.5-5.6 5.6-5.6zM377.9 445.3h10.8c3.1 0 5.6 2.5 5.6 5.6v15.8c0 3.1-2.5 5.6-5.6 5.6h-10.8c-3.1 0-5.6-2.5-5.6-5.6v-15.8c-.1-3.1 2.5-5.6 5.6-5.6zM351.9 445.3h10.8c3.1 0 5.6 2.5 5.6 5.6v16.8c0 3.1-2.5 5.6-5.6 5.6h-10.8c-3.1 0-5.6-2.5-5.6-5.6v-16.8c-.1-3.1 2.5-5.6 5.6-5.6z"
      />
      <path
        className="st18"
        d="M704.7 240.5c-2.8-5.6-2.9-12.1-4.6-18.1-3-10.7-10-20.4-20.3-24.2-5-1.9-10.6-2.1-15.7-.6-1.2.4-2.4.9-3.6 1.5-1.4.7-2.6 1.6-4.2 1.3-1.2-.2-2.3-.8-3.4-1.1-1.2-.3-2.5-.5-3.8-.6-4.8-.2-9.5 1.2-13.4 4.1-4.1 3.1-7 7.6-8.3 12.6-1.6 5.7-1.8 11.9-4.3 17.3-2.1 4.5-3.7 9.1-4.8 13.9-1.2 5-1 8.2 1.2 13 1 2.1 3.1 3.5 4.4 5.5 1.2 1.9 2 4 2.5 6.1.6 2.1 1.6 4.3 3.8 4.8.9.2 1.7-.3 1.9-1.1 0-.1.1-.3.1-.4.3-4.4-1.6-8.3-2.6-12.4-.6-2-.8-4.2-.4-6.3.4-2.4.8-4.8 1.1-7.2.6-4.4 1.2-9 3.6-12.7 1.8-2.7 4.7-5.2 7.9-5.3.4.3 1 .3 1.5.1.7.1 1.4-.2 1.7-.8 4.7-2.3 10.2-4.6 15.1-1.9 1.4.8 2.6 1.9 3.4 3.3l-.1.2s1.2 14.9 5.7 21.7c1.4 2.1 3.8 3.3 6.3 3l1.1-.1-2.5-1.1s-3.4-1.5-6.2-10.9c1 3 2.4 5.9 4.8 7.9 5.1 4 9.9-1.5 15.2-1.2 4.6.2 8.5 4 7.6 9.1-.5 3-2.2 5.7-3.6 8.3-1.1 2.1-2.9 5-1.6 7.4s4.4 2.4 6.6 1.6c2.4-1 4.5-2.6 6.1-4.7 3.5-4.4 6.9-9.9 7.5-15.7.4-6.3-3.2-11.2-5.7-16.3z"
      />
      <path
        d="M270.6 469.8c-4.3-17.3-32.7-15-32.7-15-16.5-66.2-33.9-60.2-55.1-61.4-13.9-.8-116.6 71.5-116.6 71.5-27.8-3.1-51.8-34.3-51.8-34.3-4.8 4.6-9.8 10.7-14.2 17.8v83.4c19.1 18.1 54.8 29.8 87.5 17.4 25.4-9.7 74.2-46.7 93.5-84.7v.1c.1-.4.8-.5.8 0 .7 4.5 2 9 3.1 13.5 3.5 14.2 7.3 28.4 11.2 42.6 1.7 6.2 3.4 12.5 5.2 18.8.9 3.2 1.7 6.5 2.8 9.6.2.5-.7.8-.9.2-1.3-3.8-2.3-7.7-3.4-11.6-3.9-13.9-7.7-27.9-11.3-41.9-1.7-6.5-3.4-13.1-5-19.6-.9-3.7-2-7.5-2.5-11.3l-.4 5.5c-.8 11.4-5.4 22.2-13 30.7-12.4 13.7-30.2 33.5-27.8 32.7 0 0 9.1 11.9 11.5 13.8 0 0 8.9 13.5 17.2 17.2 0 0 30.4-11.9 35.3-15.2 0 0 8.3 7.3 11.8 14 0 0 21.8 5.8 35.6-11.5.5-12.9.4-25.7-.5-38.6.1.2 23.9-26.4 19.7-43.7zm-20.3 43.4-2.4-11.4c-1.9-9.5-3.9-19-5.9-28.5-.8-3.9-1.6-7.8-2.5-11.7-.4-2.1-.9-4.2-1.5-6.2-.1-.5.7-.8.9-.2.7 2.4 1.3 4.9 1.8 7.4 3.7 16.8 6.9 33.6 10.5 50.4.1.5-.8.8-.9.2z"
        style={{
          fill: "#e6e6e6",
        }}
      />
    </g>
    <g id="Layer_3">
      <path
        d="m146.6 238.9 16.3-1c-.2 1.2-.2 2.5 0 3.7.8 5.6 5 9.6 9.4 9 4.1-.6 6.9-5 6.7-10.1l1.7-.2c-.3-.6-.7-1.2-1-1.7l-1 .1c-1-5.2-5.1-8.9-9.3-8.3-2.9.4-5.1 2.7-6.1 5.8l-16.6 1-.1 1.7zm17.6 2.5c-.6-4.6 1.8-8.8 5.4-9.3s7.1 2.8 7.8 7.4-1.8 8.8-5.4 9.3-7.1-2.8-7.8-7.4z"
        style={{
          fill: "#f4e2ca",
        }}
      />
      <path
        d="M171.4 241.6c-.4.7-1.2 1-1.9.6-.1-.1-.2-.1-.3-.2-.7-.7-.9-1.8-.4-2.7.4-.7 1.2-1 1.9-.6.1.1.2.1.3.2.8.7.9 1.9.4 2.7z"
        style={{
          fill: "#382632",
        }}
      />
      <circle className="st7" cx={174.3} cy={260.3} r={2} />
      <path
        d="M170.6 223.4c0-1.5-.9-1.8-3.3-1.1-2.4.8-4.6 2.1-6.5 3.7-3.2 2.7-3.7 7.2-2.9 6.3 1.7-2 2.6-3.2 7-5.9 2.3-1.4 5.7-1.9 5.7-3z"
        style={{
          fill: "#052620",
        }}
      />
      <path
        className="st20"
        d="M410.2 202.7c.4-1-.5-1.7-2.3-1.6-1.7.1-3.5.6-5.1 1.3-2.8 1.2-4.2 4.5-3.5 4.1 1.9-1.3 3.9-2.2 6.1-2.7 2.1-.7 4.6-.5 4.8-1.1zM420.8 203.6c-.3-1 .6-1.6 2.4-1.4 1.7.3 3.4.9 4.9 1.7 2.7 1.5 3.8 4.9 3.1 4.4-1.7-1.4-3.7-2.5-5.9-3.2-1.8-.8-4.3-.8-4.5-1.5z"
      />
      <circle className="st57" cx={407.8} cy={211.8} r={1.5} />
      <circle className="st57" cx={421.8} cy={212.8} r={1.5} />
      <ellipse className="st7" cx={414.6} cy={227.3} rx={2.7} ry={1} />
    </g>
  </svg>
  )
}

export default SvgRelationshipTwoAOneTwo 